<template>
  <div class="price-popup-content">
    <div class="total-price">
      <p class="title os-font-14-500">预估总费用</p>
      <p v-if="totalPrice > 0" class="price os-font-16-500">￥{{ totalPrice | formatMoney }}</p>
      <p v-else class="os-font-16-500">--</p>
    </div>
    <div class="price-wrapper">
      <div v-if="componentPriceData.priceList.length > 0" class="component-prices">
        <ul>
          <li v-for="(price, index) in componentPriceData.priceList" :key="index">
            <p class="component os-font-12-400">{{ price.componentName }}</p>
            <p class="prices os-font-12-400">￥{{ price.price }}</p>
          </li>
        </ul>
        <div class="repair-fees">
          <p class="os-font-12-400">
            维修费（不含人工费）
            <span v-if="totalPrice > 0" class="os-font-15-400"
              >￥{{ this.componentPriceData.totalPrice | formatMoney }}</span
            >
            <span v-else class="os-font-15-400">--</span>
          </p>
        </div>
      </div>
      <div class="shipping-fees" v-if="repairType === 6">
        <ul>
          <li>
            <p class="component os-font-12-400">寄出配送费</p>
            <p v-if="distributionFeeData.isAddressFilled" class="prices os-font-12-400">
              ￥{{ distributionFeeData.shippingFee }}
            </p>
            <p v-else class="prices os-font-12-400">填写取件地址后展示</p>
          </li>
          <li>
            <p class="component os-font-12-400">送返配送费</p>
            <p v-if="distributionFeeData.isAddressFilled" class="prices os-font-12-400">
              ￥{{ distributionFeeData.returnShippingFee }}
            </p>
            <p v-else class="prices os-font-12-400">填写取件地址后展示</p>
          </li>
        </ul>
        <div class="repair-fees">
          <p class="os-font-12-400">
            往返配送费
            <span v-if="distributionFeeData.isAddressFilled" class="os-font-15-400"
              >￥{{ distributionFeeData.totalShippingFee | formatMoney }}</span
            >
            <span v-else class="os-font-15-400">--</span>
          </p>
        </div>
      </div>
    </div>
    <div class="remark os-font-12-400" v-if="richText" v-html="richText"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'pricePopup',
  data() {
    return {}
  },
  computed: {
    ...mapState('repair', ['componentPriceData', 'distributionFeeData', 'repairType', 'priceTips']),
    totalPrice() {
      // 计算维修总费用
      if (this.repairType === 6) {
        return this.distributionFeeData.isAddressFilled
          ? Number(this.componentPriceData.totalPrice) +
              Number(this.distributionFeeData.totalShippingFee)
          : this.componentPriceData.totalPrice
      } else {
        return this.componentPriceData.totalPrice
      }
    },
    richText() {
      if (this.priceTips && this.priceTips.content) {
        const parser = new DOMParser()
        const doc = parser.parseFromString(this.priceTips.content, 'text/html')
        const elements = doc.querySelectorAll('[style]')
        elements.forEach(el => {
          el.removeAttribute('style')
        })
        return doc.body.innerHTML
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" src="./index.scss" scoped></style>
